<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  inheritAttrs: false,
});
</script>
<script setup lang="ts">import { computed as _computed } from 'vue';

export interface SMenuButtonProps {
  /**
   * Whether the button is disabled or not.
   */
  disabled?: boolean;
  /**
   * Route to navigate to.
   */
  to?: string | object | null
  /**
   * Text to be displayed in the button.
   */
  text?: string;
  /**
   * Text to be displayed at the right of the button.
   */
  secondary_text?: string;
  /**
   * Tooltip to be displayed when hovering the button.
   */
  tooltip?: string;
  /**
   * Icon to be displayed in the button.
   */
  icon?: string;
  /**
   * Button color (`primary` or `danger`). `primary` by default.
   */
  color?: 'primary' | 'danger';
  /**
   * data-track attribute for testing purposes.
   */
  dataTrack?: string
  /**
   * submenu flag
   */
  submenu?: boolean
}

const props = defineProps({
  disabled: { type: Boolean, default: false },
  to: null,
  text: null,
  secondary_text: null,
  tooltip: null,
  icon: null,
  color: { default: 'primary' },
  dataTrack: null,
  submenu: { type: Boolean }
});

type Emits = {
  /**
   * Click event emitted when the button is clicked.
   */
  (event: 'click', e: MouseEvent): void
}

const emits = defineEmits(["click"]);

;

const iconColor = _computed(() => {
  if (props.color === 'danger' && !props.disabled) {
    return 'iconDanger';
  }
  return undefined;
});

const textClasses = _computed(() => {
  const result = [];
  if (props.color === 'danger' && !props.disabled) {
    result.push('textDanger--text');
  }
  return result;
});

const link = _computed(() => {
  if (!props.to) return false;

  const isExternalLink = props.to.toString().startsWith('http');

  return {
    [isExternalLink ? 'href' : 'to']: props.to,
    target: isExternalLink ? '_blank' : undefined,
  };
});

const click = async (event: MouseEvent) => {
  emits('click', event);
};

</script>

<template lang="pug">
v-list-item(@click="click" v-bind="link" :disabled="disabled" :data-track="dataTrack")
  v-list-item-icon.align-center(v-if="icon")
    SIcon( :icon="icon" :color="iconColor" )
  v-list-item-title(
    v-if="text"
    :class="textClasses")
    .d-flex.align-center.justify-space-between
      span {{ text }}
      .caption.grey--text( v-if="secondary_text" ) {{ secondary_text }}
      slot(name="suffix")

  slot
  v-spacer
  v-list-item-action( v-if="submenu" )
    SIcon( icon="icon-chevron-right-medium" )
</template>
